import { render, staticRenderFns } from "./NewPaymentsPayoneerTable.vue?vue&type=template&id=421380fa&scoped=true"
import script from "./NewPaymentsPayoneerTable.vue?vue&type=script&lang=js"
export * from "./NewPaymentsPayoneerTable.vue?vue&type=script&lang=js"
import style0 from "./NewPaymentsPayoneerTable.vue?vue&type=style&index=0&id=421380fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421380fa",
  null
  
)

export default component.exports